import { render, staticRenderFns } from "./shoppingPerfectInformation.vue?vue&type=template&id=67bc3555&scoped=true"
import script from "./shoppingPerfectInformation.vue?vue&type=script&lang=js"
export * from "./shoppingPerfectInformation.vue?vue&type=script&lang=js"
import style0 from "./shoppingPerfectInformation.vue?vue&type=style&index=0&id=67bc3555&prod&lang=css"
import style1 from "./shoppingPerfectInformation.vue?vue&type=style&index=1&id=67bc3555&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bc3555",
  null
  
)

export default component.exports